import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M5 24h5.18l1.695-5.017h8.253L21.822 24H27L19.12 2h-6.23L5 24zm13.904-8.648-2.81-8.325h-.178l-2.814 8.325h5.802z" clip-rule="evenodd"></path><path d="M4 26h24a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4z"></path></g>';
export var TextColorOutlineSVG = function TextColorOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextColorOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextColorOutlineSVG);